import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  min-height: 100vh;
  width: 100%;
  justify-content: center;
  text-align: center;
  flex-direction: column;

  p {
    font-size: 16px;
  }
`;
